// TODO delete
RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Widget = Marionette.LayoutView;

});
